// src/components/common/RowActions.tsx
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";

export type RowActionsProps = {
  onViewDetails: () => void;
  onCancelRequest?: () => void;
  showCancelRequest?: boolean;
  onRequest?: () => void;
  showRequest?: boolean;
  disabledRequest?: boolean;
};

const RowActions: React.FC<RowActionsProps> = ({
  onViewDetails,
  onCancelRequest,
  showCancelRequest = false,
  onRequest,
  showRequest = false,
  disabledRequest = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleView = () => {
    handleClose();
    onViewDetails();
  };

  const handleCancelRequest = () => {
    handleClose();
    if (onCancelRequest) onCancelRequest();
  };

  const handleRequest = () => {
    handleClose();
    if (onRequest) onRequest();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleView}>View details</MenuItem>
        {showCancelRequest && (
          <MenuItem onClick={handleCancelRequest}>Cancel request</MenuItem>
        )}
        {showRequest && (
          <MenuItem onClick={handleRequest} disabled={disabledRequest}>
            Request again
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default RowActions;
